import { render, staticRenderFns } from "./DanhGiaKDLList.vue?vue&type=template&id=30c44204&"
import script from "./DanhGiaKDLList.vue?vue&type=script&lang=js&"
export * from "./DanhGiaKDLList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports